import Blanket from './Blanket';

export default Blanket;
